@if (loadingRunTimes()) {
  <div class="loading-display">
    <app-lt-spinner></app-lt-spinner>
  </div>
} @else {
<h4 class="text-center">Run Time</h4>
<div class="inline" *ngIf="integrationRunTimeSelected === false && addingIntegrationRunTime === false">
  <button matButton="filled" class="inline orange-button"
    (click)="addIntegrationRunTimeSwitch()">+</button>
  <br />
</div>
<div *ngIf="integrationRunTimeSelected === true && addingIntegrationRunTime === false">
  <p><b>Select a RunTime to view: </b></p>

  <mat-button-toggle-group (change)="selectIntegrationRunTime($event.value)" [hideSingleSelectionIndicator]="true">
    <mat-button-toggle *ngFor="let r of integrationRunTimes" [value]="r" [checked]="r === integrationRunTime">{{r.importTypeDescription}} - {{r.destinationEndpointName}}
    </mat-button-toggle>
  </mat-button-toggle-group>

  <button matButton="filled" class="inline add-runtime-btn orange-button"
    (click)="addIntegrationRunTimeSwitch()">+</button>
  <br />

  <h3 class="heading-float-left">{{integrationRunTime.importTypeDescription}} - {{getDisplayName(integrationRunTime.destinationEndpointName)}} RunTimes</h3>

  <button *ngIf="integrationRunTime.activePushBack" matTooltip="RunTime has active PushBack, RunTime may be pushed back automatically"
    class="inline btn pushback-btn" aria-label="PushBack Warning">
    <i class="bi bi-exclamation-circle-fill warning-icon"></i>
  </button>

  <br/>
  <br/>

  <h5>LastRunTime: {{ integrationRunTime.lastRunTime | date: 'EEEE, MMMM d, y, h:mm:ss a ZZZZ'}}</h5>
  <h5>NextRunTime: {{ integrationRunTime.nextRunTime | date: 'EEEE, MMMM d, y, h:mm:ss a ZZZZ'}}</h5>
  <div *ngIf="integrationRunTime.lastDataSent !== undefined;then lds else emptyLDS"></div>
  <ng-template #lds>
    <h5>LastDataSent: {{ integrationRunTime.lastDataSent | date: 'EEEE, MMMM d, y, h:mm:ss a ZZZZ'}}</h5>
  </ng-template>
  <ng-template #emptyLDS>
    <h5>LastDataSent: Not Populated</h5>
  </ng-template>
  <div *ngIf="checkAccess(['LOSTalker.Admin'])" class="runtime-button-row">
    <button matButton="outlined" (click)="updateIntegrationRunTime(1, 'hours')">Rollback 1 Hour</button>
    <button matButton="outlined" (click)="updateIntegrationRunTime(3, 'hours')">Rollback 3 Hours</button>
    <button matButton="outlined" (click)="updateIntegrationRunTime(12, 'hours')">Rollback 12 Hours</button>
    <button matButton="outlined" (click)="rollbackIntegrationRuntime('StartOfDay')">Start of Day</button>
    <button matButton="outlined" (click)="rollbackIntegrationRuntime('StartOfMonth')">Start of Month</button>
    <br />
    <br />
    <p><b>Select a date and time for LastRunTime: </b></p>
    <app-lt-datetimepicker class="datetime-picker" placeholder="Enter a date and time" format="MM/dd/yyyy hh:mm:ss a"
      [(value)]="lastRunTimeDateInput">
    </app-lt-datetimepicker>
    <br />
    <br />
    <p><b>Select a date and time for NextRunTime: </b></p>
    <app-lt-datetimepicker class="datetime-picker" placeholder="Enter a date and time" format="MM/dd/yyyy hh:mm:ss a"
      [(value)]="nextRunTimeDateInput">
    </app-lt-datetimepicker>
    <br />
    <br />
  </div>
  <button matButton="outlined" [disabled]="savingIntegrationRuntime" class="save-button"
      (click)="updateIntegrationRunTime()" *ngIf="checkAccess(['LOSTalker.Admin'])">Set RunTime</button>

    <button matButton="outlined" *ngIf="checkAccess(['LOSTalker.Admin'])" [disabled]="savingIntegrationRuntime" class="delete-button"
    (click)="setDeletingIntegrationRunTime()">Delete RunTime</button>
</div>

<div *ngIf="addingIntegrationRunTime === true">
  <button matButton="outlined" *ngIf="integrationRunTimes.length !== 0" class="inline orange-button"
    (click)="selectIntegrationRunTime(integrationRunTimes[0])">Back</button>

  <br />
  <br />

  <mat-form-field appearance="fill">
    <mat-label>Destination Endpoint</mat-label>
    <mat-select (selectionChange)="selectDestinationEndpoint($event)">
      <mat-option *ngFor="let dest of destinationEndpoints()" [value]="dest">
        {{dest.displayName}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <br />

  <mat-label>Import Types:</mat-label>
  <br />

  <app-lt-multiselect-t
    [data]="importTypes"
    textField="typeDescription"
    valueField="importTypeId"
    [(ngModel)]="selectedImportTypes"
  ></app-lt-multiselect-t>

  <div *ngIf="checkAccess(['LOSTalker.Admin'])">
    <br />
    <br />
    <p><b>Select a date and time for LastRunTime: </b></p>
    <app-lt-datetimepicker class="datetime-picker" placeholder="Enter a date and time" format="MM/dd/yyyy hh:mm:ss a"
      [(value)]="lastRunTimeDateInput">
    </app-lt-datetimepicker>
    <br />
    <br />
    <p><b>Select a date and time for NextRunTime: </b></p>
    <app-lt-datetimepicker class="datetime-picker" placeholder="Enter a date and time" format="MM/dd/yyyy hh:mm:ss a"
      [(value)]="nextRunTimeDateInput">
    </app-lt-datetimepicker>
    <br />
    <br />
    <br />
    <br />
    <button matButton="outlined" [disabled]="savingIntegrationRuntime" class="save-button" (click)="addIntegrationRunTime()">Add
      RunTime</button>
  </div>
</div>
} <!-- end @else loadingRunTimes -->

<ng-template #deleteRunTimeDialog>
  <h2 matDialogTitle>Confirm Deleting RunTime</h2>
  <mat-dialog-content>
    The {{integrationRunTime.importTypeDescription}} - {{integrationRunTime.destinationEndpointName}} runtime will be deleted.
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton matDialogClose (click)="deleteIntegrationRunTime()">Delete</button>
    <button matButton matDialogClose>Cancel</button>
  </mat-dialog-actions>
</ng-template>
